import jwtDecode from 'jwt-decode';
import moment from 'moment';

import { diffDatesInMilliseconds } from './date';
import { isProductionEnv } from './general';

interface TokenExtractedDataT {
  admin: boolean;
  multi: boolean;
  organization: string;
  username: string;
  fullname: string;
  exp: number; // Expiry in milliseconds
}

interface RealmAccess {
  roles: Array<string>;
}

interface RawExtractedData {
  exp: number;
  'realm_access': RealmAccess;
  'preferred_username': string;
  name: string;
}

const getOrganizationFromLocationHost = (): string => {
  const locationHost = window.location.hostname;
  let organization: string = '';
  if (isProductionEnv()) {
    organization = locationHost
      .replace(window.runtimeConfigs.serverName, '')
      .replace('.', '');
  } else {
    const subdomains = locationHost.split('.');
    if (subdomains.length >= 2) {
      [organization] = subdomains;
    }
  }
  return organization;
};

const authToken = {
  decode(token: string): any {
    return jwtDecode(token);
  },

  extractData(token: string | null): TokenExtractedDataT {
    const tokenData: RawExtractedData = this.decode(token as string);
    const isExpired = moment.unix(tokenData.exp).isBefore();
    if (isExpired) {
      throw new Error('Token expired');
    }
    const roles: Array<string> = tokenData?.realm_access?.roles;
    const expiredIn = diffDatesInMilliseconds(new Date(), new Date(tokenData.exp * 1000));
    return {
      admin: roles?.includes('admin'),
      multi: roles?.includes('multi-org'),
      organization: getOrganizationFromLocationHost(),
      username: tokenData?.preferred_username,
      fullname: tokenData?.name,
      exp: expiredIn,
    };
  },
};

export default authToken;
